parseQueryString